import React from 'react';
import styles from './MetricWidget.module.css';
import { SimpleGauge, SimpleGaugeColor } from './SimpleGauge';
import { GaugeData, GaugeType } from 'model';

type GaugeWidgetProps = {
  title: string;
  data: GaugeData | undefined;
  isLoading: boolean;
}

const gaugeTypeToColor = (type: GaugeType): SimpleGaugeColor => {
  switch(type) {
    case GaugeType.CRITICAL:
      return SimpleGaugeColor.RED;
    case GaugeType.WARNING:
      return SimpleGaugeColor.ORANGE;
    case GaugeType.HEALTHY:
      return SimpleGaugeColor.GREEN;
    case GaugeType.OFFLINE:
      return SimpleGaugeColor.YELLOW;
  }
}

export const GaugeWidget: React.FC<GaugeWidgetProps> = React.memo(({title, data, isLoading}) => {
  return (
    <div className={styles.root}>
      <div className={styles.header}>{title}</div>
      <div className={styles.gaugeContainer}>
        <SimpleGauge
          type        = {gaugeTypeToColor(data !== undefined ? data.type : GaugeType.HEALTHY)}
          count       = {data?.count || 0}
          percentage  = {data?.percentage || 0}
          isLoading   = {isLoading}
        />
      </div>
    </div>
  );
});
